var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464.8 130.2",
    style: {
      enableBackground: "new 0 0 464.8 130.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.8;fill:url(#SVGID_2_);}\r\n\t.st2{opacity:0.8;fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{opacity:0.8;fill:url(#SVGID_5_);}\r\n\t.st5{opacity:0.8;fill:url(#SVGID_6_);}\r\n\t.st6{opacity:0.8;fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{opacity:0.8;fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{opacity:0.8;fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.2945,
    y1: 64.8414,
    x2: 121.7809,
    y2: 64.8414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF68E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2389,
    style: {
      stopColor: "#FFF28B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4812,
    style: {
      stopColor: "#FFE680"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7252,
    style: {
      stopColor: "#FED16F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    style: {
      stopColor: "#FDB557"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDB153"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 65.5,
    cy: 64.8,
    r: 56.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.2945,
    y1: 68.6519,
    x2: 121.7786,
    y2: 68.6519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3698,
    style: {
      stopColor: "#FFEE00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    style: {
      stopColor: "#FFC81D",
      stopOpacity: 0.09706956
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4957,
    style: {
      stopColor: "#FFA836",
      stopOpacity: 0.1998
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5661,
    style: {
      stopColor: "#FF8D4A",
      stopOpacity: 0.3115
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6428,
    style: {
      stopColor: "#FF7959",
      stopOpacity: 0.4332
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    style: {
      stopColor: "#FF6A65",
      stopOpacity: 0.57
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8325,
    style: {
      stopColor: "#FF626B",
      stopOpacity: 0.7343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5F6D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103,22.8C94.7,28,84.9,31,74.4,31.2c-15.1,0.3-28.8-5.4-39.1-14.9l-7.8,7.1h0C16.1,33.9,9,49,9.3,65.7 c0.5,31.1,26.1,55.8,57.2,55.3c31.1-0.5,55.8-26.1,55.3-57.2C121.5,47.5,114.3,32.9,103,22.8z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 66.1171,
    cy: -17.5407,
    r: 154.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3698,
    style: {
      stopColor: "#7CCEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#6FC7F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#46B2E8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103,22.9C92.5,31.7,79,37,64.3,37C50.1,37,37.1,32.1,26.9,24C15.8,34.5,9,49.3,9.3,65.7 c0.5,31.1,26.1,55.8,57.2,55.3c31.1-0.5,55.8-26.1,55.3-57.2C121.5,47.5,114.3,33,103,22.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.2946,
    y1: 71.9528,
    x2: 121.7786,
    y2: 71.9528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDB153"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103,22.9C92.5,31.7,79,37,64.3,37C50.1,37,37.1,32.1,26.9,24C15.8,34.5,9,49.3,9.3,65.7 c0.5,31.1,26.1,55.8,57.2,55.3c31.1-0.5,55.8-26.1,55.3-57.2C121.5,47.5,114.3,33,103,22.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.2946,
    y1: 72.5084,
    x2: 121.7786,
    y2: 72.5084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B620B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06424351,
    style: {
      stopColor: "#BA23A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1775,
    style: {
      stopColor: "#C7298B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3255,
    style: {
      stopColor: "#DA345C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3333,
    style: {
      stopColor: "#DB3559"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    style: {
      stopColor: "#E2505E",
      stopOpacity: 0.8385
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7051,
    style: {
      stopColor: "#F28E68",
      stopOpacity: 0.4424
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    style: {
      stopColor: "#FBB46F",
      stopOpacity: 0.1518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC371",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.5,41c-10,8.1-22.7,13-36.5,13.3c-22.5,0.4-42.3-11.8-52.8-30c-0.1-0.1-0.2-0.2-0.3-0.3 C15.8,34.5,9,49.3,9.3,65.7c0.5,31.1,26.1,55.8,57.2,55.3c31.1-0.5,55.8-26.1,55.3-57.2C121.6,55.7,119.8,47.9,116.5,41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.2946,
    y1: 72.4817,
    x2: 121.7786,
    y2: 72.4817
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5F6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FC8738"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84.5,66.7c-27.2,0-50.1-18-57.6-42.8C15.8,34.4,9,49.3,9.3,65.7c0.5,31.1,26.1,55.8,57.2,55.3 c31.1-0.5,55.8-26.1,55.3-57.2c-0.1-3.2-0.4-6.3-0.9-9.3C110.7,62.2,98.2,66.7,84.5,66.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.2946,
    y1: 86.8721,
    x2: 121.7786,
    y2: 86.8721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5F6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C50048"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M121,55.3c-16.8,13.1-38.4,20.2-61.3,18.1c-18.8-1.7-35.7-9.3-49-20.7c-0.9,4.2-1.4,8.6-1.3,13 c0.5,31.1,26.1,55.8,57.2,55.3c31.1-0.5,55.8-26.1,55.3-57.2C121.7,60.9,121.4,58.1,121,55.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.6365,
    y1: 90.02,
    x2: 121.7721,
    y2: 90.02
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9850FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1146,
    style: {
      stopColor: "#9E44E5",
      stopOpacity: 0.1146
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4267,
    style: {
      stopColor: "#AF27A2",
      stopOpacity: 0.4267
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6889,
    style: {
      stopColor: "#BB1271",
      stopOpacity: 0.6889
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8878,
    style: {
      stopColor: "#C20553",
      stopOpacity: 0.8878
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C50048"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M66.5,121c30.5-0.5,54.9-25.2,55.3-55.5c0-1.4,0-2.8-0.1-3.9c0-0.9-0.1-1.7-0.2-2.6 c-14.4,16.5-38.9,28.8-61.8,26.8c-18.8-1.7-35.7-9.3-49-20.7C10.2,67,9.9,69,9.6,71C12.8,99.5,37.2,121.5,66.5,121z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.2945,
    y1: 87.9398,
    x2: 121.7786,
    y2: 87.9398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#34307F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08503813,
    style: {
      stopColor: "#512B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2548,
    style: {
      stopColor: "#842277"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4222,
    style: {
      stopColor: "#AF1A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    style: {
      stopColor: "#D0156F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7368,
    style: {
      stopColor: "#E8106C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8793,
    style: {
      stopColor: "#F60E6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB0D6A"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.1,92.6c-24.7,0-45.9-14.9-55.2-36.2c-0.5,3-0.7,6.2-0.6,9.3c0.5,31.1,26.1,55.8,57.2,55.3 c31.1-0.5,55.8-26.1,55.3-57.2c-0.1-3.1-0.4-6.1-0.9-9C112,77,90.4,92.6,65.1,92.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 75.296,
    cy: 120.5216,
    r: 74.7583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C50048",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1368,
    style: {
      stopColor: "#B50247",
      stopOpacity: 0.05472609
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4058,
    style: {
      stopColor: "#8A0943",
      stopOpacity: 0.1623
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7773,
    style: {
      stopColor: "#45133E",
      stopOpacity: 0.3109
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#19193A",
      stopOpacity: 0.4
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M20.8,98.9c7,2.8,14.6,4.4,22.6,4.4c13.9,0,26.8-4.7,37-12.7c-4.9,1.3-10,2-15.4,2 c-24.7,0-45.9-14.9-55.2-36.2c-0.5,3-0.7,6.2-0.6,9.3C9.5,78.2,13.8,89.7,20.8,98.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 118.6999,
    cy: 143.0334,
    r: 99.3727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3357,
    style: {
      stopColor: "#B620B4",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3938,
    style: {
      stopColor: "#AB24B1",
      stopOpacity: 0.27
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6703,
    style: {
      stopColor: "#7A38A5",
      stopOpacity: 0.6029
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8811,
    style: {
      stopColor: "#5C449D",
      stopOpacity: 0.8568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#51489A"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M121.8,63.8c-0.1-3.1-0.4-6.1-0.9-9c-4.3,10.8-11.7,20-21.1,26.7c-1.6,15.2-9.3,28.7-20.7,37.9 C104,113.2,122.2,90.5,121.8,63.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9918,
    y1: 31.1666,
    x2: 105.0911,
    y2: 31.1666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5F6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    style: {
      stopColor: "#FDB153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1768,
    style: {
      stopColor: "#FDB358"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2369,
    style: {
      stopColor: "#FDBB68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    style: {
      stopColor: "#FEC682"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3752,
    style: {
      stopColor: "#FED6A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4498,
    style: {
      stopColor: "#FEEBD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6204,
    style: {
      stopColor: "#FFFCDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7097,
    style: {
      stopColor: "#FFFAC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8003,
    style: {
      stopColor: "#FFFAC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#FFF9BD"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M65.5,39.5c15.1-0.3,28.8-5.7,39.6-14.6c-0.7-0.7-1.4-1.3-2.1-2C92.5,31.7,79,37,64.3,37 C50.1,37,37.1,32.1,26.9,24c-0.6,0.6-1.3,1.2-1.9,1.9C36.1,34.6,50.2,39.7,65.5,39.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.6558,
    y1: 46.6941,
    x2: 121.2051,
    y2: 46.6941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7D8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2144,
    style: {
      stopColor: "#FE8F79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5454,
    style: {
      stopColor: "#FDB153"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#FCAC53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7965,
    style: {
      stopColor: "#D5314B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9032,
    style: {
      stopColor: "#C50048"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A1C7C",
      stopOpacity: 0.9
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120.8,54.5c-10.1,7.7-22.7,12.2-36.3,12.2c-27.2,0-50.1-18-57.6-42.8c-0.8,0.7-1.5,1.5-2.3,2.3 c8,25.5,32,43.7,60.1,43.3c13.7-0.2,26.4-4.9,36.5-12.7C121.1,56,121,55.2,120.8,54.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 95.5348,
    cy: 144.5788,
    r: 111.3342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A1C7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09566404,
    style: {
      stopColor: "#7E1D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    style: {
      stopColor: "#8A207E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2873,
    style: {
      stopColor: "#9E2681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3833,
    style: {
      stopColor: "#BA2D85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    style: {
      stopColor: "#DE378A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5514,
    style: {
      stopColor: "#FF408E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5981,
    style: {
      stopColor: "#E6398B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    style: {
      stopColor: "#C02F85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7666,
    style: {
      stopColor: "#A12781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8485,
    style: {
      stopColor: "#8B217E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9274,
    style: {
      stopColor: "#7E1D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A1C7C"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M65.1,92.6c-24.7,0-45.9-14.9-55.2-36.2c-0.3,1.7-0.4,3.4-0.5,5.2c10.7,20.2,32.1,33.7,56.5,33.3 c24.7-0.4,45.7-15,55.6-35.9c-0.1-1.4-0.3-2.8-0.6-4.2C112,77,90.4,92.6,65.1,92.6z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 115.4331,
    cy: 36.2846,
    r: 65.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF68E"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M65.5,8.6C61.6,8.6,57.8,9,54,9.8c10.2,9,23.6,14.5,38.3,14.2c3.6-0.1,7.1-0.5,10.5-1.2 C93,14,79.9,8.6,65.5,8.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M198.6,76.9c-2.4,4.4-5.9,7.8-10.5,10.3c-4.6,2.4-10.1,3.7-16.4,3.7H151V32.6h20.7c6.3,0,11.8,1.2,16.4,3.6 c4.6,2.4,8.1,5.8,10.5,10.2c2.4,4.4,3.6,9.5,3.6,15.3C202.2,67.4,201,72.5,198.6,76.9z M185.3,75.5c3.4-3.3,5.2-7.9,5.2-13.9 c0-6-1.7-10.6-5.2-13.9c-3.4-3.3-8.3-5-14.6-5h-8.1v37.7h8.1C177,80.4,181.8,78.8,185.3,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M211.6,27.4c1.3-1.2,3.1-1.8,5.2-1.8c2.1,0,3.9,0.6,5.2,1.8c1.3,1.2,2,2.7,2,4.6c0,1.8-0.7,3.3-2,4.5 c-1.3,1.2-3.1,1.8-5.2,1.8c-2.1,0-3.9-0.6-5.2-1.8c-1.3-1.2-2-2.7-2-4.5C209.6,30.1,210.3,28.6,211.6,27.4z M222.6,45.1v45.7H211 V45.1H222.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M261,47.3c2.8,1.8,4.7,4.3,5.9,7.3v-9.5h11.6V91c0,4.2-0.8,8-2.5,11.4c-1.7,3.4-4.2,6-7.5,8 c-3.3,1.9-7.4,2.9-12.1,2.9c-6.6,0-11.9-1.6-16-4.7c-4.1-3.1-6.5-7.4-7.4-12.8h11.5c0.7,2.3,1.9,4.1,3.8,5.4 c1.9,1.3,4.3,1.9,7.3,1.9c3.4,0,6.2-1,8.3-3c2.1-2,3.1-5,3.1-9.1v-9.7c-1.2,3.1-3.1,5.5-5.9,7.4c-2.8,1.8-6.1,2.8-9.9,2.8 c-3.9,0-7.3-0.9-10.4-2.8c-3.1-1.9-5.5-4.6-7.2-8.1c-1.7-3.5-2.6-7.7-2.6-12.5c0-4.8,0.9-9,2.6-12.5c1.7-3.5,4.1-6.3,7.2-8.1 c3.1-1.9,6.5-2.8,10.4-2.8C254.9,44.5,258.2,45.4,261,47.3z M246,58.2c-2.2,2.4-3.3,5.6-3.3,9.7s1.1,7.4,3.3,9.7 c2.2,2.3,5.1,3.5,8.7,3.5c3.5,0,6.4-1.2,8.7-3.6c2.3-2.4,3.4-5.6,3.4-9.6c0-4.1-1.1-7.3-3.4-9.7c-2.3-2.4-5.2-3.6-8.7-3.6 C251.1,54.7,248.2,55.9,246,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M289.6,27.4c1.3-1.2,3.1-1.8,5.2-1.8s3.9,0.6,5.2,1.8c1.3,1.2,2,2.7,2,4.6c0,1.8-0.7,3.3-2,4.5 c-1.3,1.2-3.1,1.8-5.2,1.8s-3.9-0.6-5.2-1.8c-1.3-1.2-2-2.7-2-4.5C287.6,30.1,288.3,28.6,289.6,27.4z M300.6,45.1v45.7H289V45.1 H300.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M335.6,80.8v10h-6.1c-5.1,0-9-1.2-11.8-3.7c-2.7-2.5-4.1-6.6-4.1-12.4V54.9h-6.4v-9.8h6.4V33.8h11.6v11.3 h10.2v9.8h-10.2v20c0,2.2,0.4,3.7,1.3,4.6c0.9,0.9,2.4,1.3,4.5,1.3H335.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M371.7,47.3c2.8,1.8,4.7,4.3,5.9,7.3v-9.5h11.6v45.7h-11.6v-9.6c-1.2,3.1-3.1,5.5-5.9,7.4 c-2.8,1.8-6.1,2.8-9.9,2.8c-3.9,0-7.3-0.9-10.4-2.8c-3.1-1.9-5.5-4.6-7.2-8.1c-1.7-3.5-2.6-7.7-2.6-12.5c0-4.8,0.9-9,2.6-12.5 c1.7-3.5,4.1-6.3,7.2-8.1c3.1-1.9,6.5-2.8,10.4-2.8C365.7,44.5,369,45.4,371.7,47.3z M356.7,58.2c-2.2,2.4-3.3,5.6-3.3,9.7 s1.1,7.4,3.3,9.7c2.2,2.3,5.1,3.5,8.7,3.5c3.5,0,6.4-1.2,8.7-3.6c2.3-2.4,3.4-5.6,3.4-9.6c0-4.1-1.1-7.3-3.4-9.7 c-2.3-2.4-5.2-3.6-8.7-3.6C361.8,54.7,358.9,55.9,356.7,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M427.5,90.8l-10.4-14.7l-8.7,14.7h-12.8L410.7,67l-15.4-21.9h13l10.2,14.4l8.7-14.4H440l-15.3,23.2 l15.9,22.5H427.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.ae70499bbdb71e32b69bbc7e741c31dd.svg";
export { ForwardRef as ReactComponent };